export default __webpack_public_path__ + "static/media/docker.c884bb50.png";